import React from 'react';
import { Popup, ToolbarItem } from 'devextreme-react/popup';
import { connect } from "react-redux";
// import * as contractOtherPriceCrud from '../../../../crud/contractOtherPrice.crud';
import DataGrid, { Scrolling, ColumnFixing, HeaderFilter, FilterPanel, Export } from 'devextreme-react/data-grid';
// import { withRouter } from '../../../../shared/hoc/withRouter';
import Common from '../../../../shared/common';
import { injectIntl } from "react-intl";
import { withSnackbar } from 'notistack';
import { exportDataGrid } from 'devextreme/excel_exporter';
import ExcelJS from 'exceljs';
import saveAs from 'file-saver';
import * as migrationCrud from '../../../../crud/migration.crud';

class MigrationErrorLogDetails extends React.Component {
  constructor(props) {
    super(props);
    this.gridRef = React.createRef();
    // this.changeStates = GetDatePriceChangeStates(props.lang);
    this.state = {
      migrationErrorDetails: null,
    }
  }

  componentDidMount() {
    this.fetchMigrationErrorDetails();
  }
  componentDidUpdate() {
    this.fetchMigrationErrorDetails();
  }
  componentWillUnmount() {
    if (this.timer) {
      clearTimeout(this.timer);
    }
  }
  fetchMigrationErrorDetails = async () => {
    if (this.props.migrationItem && !this.state.migrationErrorDetails) {
      if (this.gridRef?.current?.instance) {
        this.gridRef.current.instance().beginCustomLoading();
      }


      const response = await migrationCrud.getFailedRecords(this.props.migrationItem.migrationid);
      this.setState({ migrationErrorDetails: response.data }, () => {
        if (this.gridRef?.current?.instance) {
          this.gridRef.current.instance().endCustomLoading();
        }
      })
    }
  }
  onClose = () => {
    this.setState({ migrationErrorDetails: null }, this.props.onClose())
  }


  onExporting = (e) => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet(this.props.intl.formatMessage({ id: 'REGISTER.EXPORTS.MAIN_SHEET' }));

    exportDataGrid({
      component: this.gridRef.current.instance,
      worksheet: worksheet,
    }).then(() => {  // Using arrow function here
      workbook.xlsx.writeBuffer()
        .then((buffer) => {  // Using arrow function here to preserve 'this'
          saveAs(
            new Blob([buffer], { type: 'application/octet-stream' }),
            this.props.migrationItem?.filename + '_Errors.xlsx'
          );
        });
    });
  };
  onToolbarPreparing(e) {
    var toolbarItems = e.toolbarOptions.items;

    toolbarItems.push({
      widget: "dxButton",
      options: { icon: "user", text: "User", onClick: function () { } },
      location: "after"
    });
  }
  render() {
    return (
      <Popup
        visible={!!this.props.migrationItem}
        onHiding={this.onClose}
        dragEnabled={true}
        hideOnOutsideClick={true}
        showTitle={true}
        // title={this.props.migrationItem?.filename}
        width='80vw'
        height='82vh'
      >
        <DataGrid
          ref={this.gridRef}
          width='100%'
          height='100%'
          dataSource={this.state.migrationErrorDetails}
          keyExpr="migrationrecordid"
          hoverStateEnabled={false}
          rowAlternationEnabled={true}
          noDataText={'No Data'}
          showBorders={true}
          showColumnLines={true}
          showRowLines={true}
          remoteOperations={false}
          // onExporting={this.onExporting}
          wordWrapEnabled={true}
          columns={[
            {
              caption: "Row Number",
              dataField: "rownum",
            },
            {
              caption: "Process Date",
              dataField: "processdate",
              dataType: "date",
              format: 'dd/MM/yyyy'
            },
            {
              caption: "Error",
              dataType: "string",
              dataField: "error",
            },
            {
              caption: "Data",
              dataType: "string",
              dataField: "data",
            },
          ]}
        >
          <ColumnFixing enabled={true} />
          <Scrolling mode="virtual" showScrollbar={true} useNative={true} columnRenderingMode="virtual" rowRenderingMode="virtual" />

        </DataGrid>
        <ToolbarItem
          text={this.props.migrationItem?.filename}
          location="before">
        </ToolbarItem>
        <ToolbarItem
          widget="dxButton"
          location="after"
          options={{
            icon: "xlsfile",
            onClick: this.onExporting
          }}>
        </ToolbarItem>
      </Popup>
    );
  }
}

const mapStateToProps = store => ({
  lang: store.i18n.lang
});

export default injectIntl(withSnackbar(connect(mapStateToProps)(MigrationErrorLogDetails)));